export const version = '2.11.6';
//# sourceMappingURL=version.js.map